import { api, usePostTwoFactorLoginMutation } from 'api/rtk-api'
import { AuthyCodeField } from 'components/core-v2/molecules/fields/authyCode'
import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { LocationWithState } from 'types/location'

import { PATH } from '../../../const'

interface Props {
  redirectOnLockedOut: boolean
  redirectOnSuccess: boolean
}
export const useLogin2FA = ({ redirectOnLockedOut, redirectOnSuccess }: Props) => {
  const navigate = useNavigate()
  const location = useLocation()
  const [fireLogin, loginStatus] = usePostTwoFactorLoginMutation()
  const [triggerGetUser, userStatus] = api.useLazyGetUsermanagerCurrentQuery()
  const user = userStatus.data

  const onSubmit = (values: AuthyCodeField) => {
    // 1. Fire login
    fireLogin({
      apiTwoFactorLoginUser: {
        isRecovery: false,
        verificationCode: Object.values(values).join('')
      }
    })
  }

  useEffect(() => {
    if (loginStatus.isSuccess) {
      // 2. Get the user
      triggerGetUser()
    }
  }, [loginStatus.isSuccess, navigate, triggerGetUser])

  useEffect(() => {
    // 3. When we have the user data, redirect the user
    if (redirectOnSuccess && user) {
      const redirectPath = (location.state as any)?.from
        ? (location as LocationWithState).state.from.pathname
        : PATH.home

      navigate(redirectPath)
    }
  }, [location, navigate, redirectOnSuccess, user])

  useEffect(() => {
    // 4. If the user is locked out, redirect the user
    if (redirectOnLockedOut && (loginStatus.error as any)?.originalStatus === 423) {
      navigate(PATH.accountLocked)
    }
    if (redirectOnLockedOut && (loginStatus.error as any)?.originalStatus === 403) {
      navigate(PATH.accountInactive)
    }
  }, [loginStatus, loginStatus.error, navigate, redirectOnLockedOut])

  const isLoading = loginStatus.isLoading || userStatus.isLoading
  const isError = loginStatus.isError || userStatus.isError
  const isSuccess = loginStatus.isSuccess && userStatus.isSuccess

  return [onSubmit, { isError, isLoading, isSuccess }] as const
}
